const baseUrl = "https://onlinemarketview.com/web/";
const liveRateUrl =
  "https://onlinemarketview.com/web/authController/getLiveRate";

// Use HTTPS so live HTTPS builds are not blocked by mixed-content rules
const optionBaseUrl = "https://onlinemarketview.com/mcx/";
const optionCategoryUrl = optionBaseUrl + "authController/getOptionCategory";
const optionExpiryUrl = optionBaseUrl + "authController/getOptionExpiry";

export { baseUrl, liveRateUrl, optionCategoryUrl, optionExpiryUrl };
